export default __webpack_public_path__ + "static/media/goopter-bellabot-food-delivery.e344e95d.jpg";